module.exports = __webpack_public_path__ + "img/locations-ua.c24fc87b.png";